/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RoadmapRouteImport } from './routes/roadmap'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReleaseNotesRouteImport } from './routes/release-notes'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MyDocumentsRouteImport } from './routes/my-documents'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FeaturesRouteImport } from './routes/features'
import { Route as DocumentationRouteImport } from './routes/documentation'
import { Route as DataProcessingRouteImport } from './routes/data-processing'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PIdRouteImport } from './routes/p.$id'
import { Route as DIdRouteImport } from './routes/d.$id'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RoadmapRoute = RoadmapRouteImport.update({
  id: '/roadmap',
  path: '/roadmap',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ReleaseNotesRoute = ReleaseNotesRouteImport.update({
  id: '/release-notes',
  path: '/release-notes',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const MyDocumentsRoute = MyDocumentsRouteImport.update({
  id: '/my-documents',
  path: '/my-documents',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturesRoute = FeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentationRoute = DocumentationRouteImport.update({
  id: '/documentation',
  path: '/documentation',
  getParentRoute: () => rootRouteImport,
} as any)
const DataProcessingRoute = DataProcessingRouteImport.update({
  id: '/data-processing',
  path: '/data-processing',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiesRoute = CookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PIdRoute = PIdRouteImport.update({
  id: '/p/$id',
  path: '/p/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DIdRoute = DIdRouteImport.update({
  id: '/d/$id',
  path: '/d/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/cookies': typeof CookiesRoute
  '/dashboard': typeof DashboardRoute
  '/data-processing': typeof DataProcessingRoute
  '/documentation': typeof DocumentationRoute
  '/features': typeof FeaturesRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/my-documents': typeof MyDocumentsRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/release-notes': typeof ReleaseNotesRoute
  '/reset-password': typeof ResetPasswordRoute
  '/roadmap': typeof RoadmapRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/d/$id': typeof DIdRoute
  '/p/$id': typeof PIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/cookies': typeof CookiesRoute
  '/dashboard': typeof DashboardRoute
  '/data-processing': typeof DataProcessingRoute
  '/documentation': typeof DocumentationRoute
  '/features': typeof FeaturesRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/my-documents': typeof MyDocumentsRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/release-notes': typeof ReleaseNotesRoute
  '/reset-password': typeof ResetPasswordRoute
  '/roadmap': typeof RoadmapRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/d/$id': typeof DIdRoute
  '/p/$id': typeof PIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/cookies': typeof CookiesRoute
  '/dashboard': typeof DashboardRoute
  '/data-processing': typeof DataProcessingRoute
  '/documentation': typeof DocumentationRoute
  '/features': typeof FeaturesRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/my-documents': typeof MyDocumentsRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/release-notes': typeof ReleaseNotesRoute
  '/reset-password': typeof ResetPasswordRoute
  '/roadmap': typeof RoadmapRoute
  '/settings': typeof SettingsRoute
  '/terms': typeof TermsRoute
  '/d/$id': typeof DIdRoute
  '/p/$id': typeof PIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/contact'
    | '/cookies'
    | '/dashboard'
    | '/data-processing'
    | '/documentation'
    | '/features'
    | '/forgot-password'
    | '/login'
    | '/my-documents'
    | '/privacy'
    | '/register'
    | '/release-notes'
    | '/reset-password'
    | '/roadmap'
    | '/settings'
    | '/terms'
    | '/d/$id'
    | '/p/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/contact'
    | '/cookies'
    | '/dashboard'
    | '/data-processing'
    | '/documentation'
    | '/features'
    | '/forgot-password'
    | '/login'
    | '/my-documents'
    | '/privacy'
    | '/register'
    | '/release-notes'
    | '/reset-password'
    | '/roadmap'
    | '/settings'
    | '/terms'
    | '/d/$id'
    | '/p/$id'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/contact'
    | '/cookies'
    | '/dashboard'
    | '/data-processing'
    | '/documentation'
    | '/features'
    | '/forgot-password'
    | '/login'
    | '/my-documents'
    | '/privacy'
    | '/register'
    | '/release-notes'
    | '/reset-password'
    | '/roadmap'
    | '/settings'
    | '/terms'
    | '/d/$id'
    | '/p/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  ContactRoute: typeof ContactRoute
  CookiesRoute: typeof CookiesRoute
  DashboardRoute: typeof DashboardRoute
  DataProcessingRoute: typeof DataProcessingRoute
  DocumentationRoute: typeof DocumentationRoute
  FeaturesRoute: typeof FeaturesRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  MyDocumentsRoute: typeof MyDocumentsRoute
  PrivacyRoute: typeof PrivacyRoute
  RegisterRoute: typeof RegisterRoute
  ReleaseNotesRoute: typeof ReleaseNotesRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  RoadmapRoute: typeof RoadmapRoute
  SettingsRoute: typeof SettingsRoute
  TermsRoute: typeof TermsRoute
  DIdRoute: typeof DIdRoute
  PIdRoute: typeof PIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roadmap': {
      id: '/roadmap'
      path: '/roadmap'
      fullPath: '/roadmap'
      preLoaderRoute: typeof RoadmapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/release-notes': {
      id: '/release-notes'
      path: '/release-notes'
      fullPath: '/release-notes'
      preLoaderRoute: typeof ReleaseNotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-documents': {
      id: '/my-documents'
      path: '/my-documents'
      fullPath: '/my-documents'
      preLoaderRoute: typeof MyDocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/features': {
      id: '/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof FeaturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documentation': {
      id: '/documentation'
      path: '/documentation'
      fullPath: '/documentation'
      preLoaderRoute: typeof DocumentationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-processing': {
      id: '/data-processing'
      path: '/data-processing'
      fullPath: '/data-processing'
      preLoaderRoute: typeof DataProcessingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookies': {
      id: '/cookies'
      path: '/cookies'
      fullPath: '/cookies'
      preLoaderRoute: typeof CookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$id': {
      id: '/p/$id'
      path: '/p/$id'
      fullPath: '/p/$id'
      preLoaderRoute: typeof PIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/d/$id': {
      id: '/d/$id'
      path: '/d/$id'
      fullPath: '/d/$id'
      preLoaderRoute: typeof DIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  ContactRoute: ContactRoute,
  CookiesRoute: CookiesRoute,
  DashboardRoute: DashboardRoute,
  DataProcessingRoute: DataProcessingRoute,
  DocumentationRoute: DocumentationRoute,
  FeaturesRoute: FeaturesRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  MyDocumentsRoute: MyDocumentsRoute,
  PrivacyRoute: PrivacyRoute,
  RegisterRoute: RegisterRoute,
  ReleaseNotesRoute: ReleaseNotesRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  RoadmapRoute: RoadmapRoute,
  SettingsRoute: SettingsRoute,
  TermsRoute: TermsRoute,
  DIdRoute: DIdRoute,
  PIdRoute: PIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
